import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';


const InactivityLogoutTimer = () => {
    const auth = useAuth()
    // const navigate = useNavigate()

    const checkForInactivity = () => {
        const expireTimeString = localStorage.getItem('expireTime');
        const expireTime = expireTimeString ? parseInt(expireTimeString) : 0;

        if (expireTime > 0 && expireTime < Date.now()) {
            localStorage.removeItem('expireTime');
            // auth.removeUser()
            auth.signoutRedirect({ id_token_hint: auth.user?.id_token });
            // navigate({ to: '/logout' });
        }
    };

    const updateExpiryTime = () => {
        const expireTime = Date.now() + import.meta.env.VITE_TIMEOUT * 60 * 1000; // timeout in milliseconds
        localStorage.setItem('expireTime', expireTime.toString());
    };

    useEffect(() => {
        const interval = setInterval(() => {
            checkForInactivity();
        }, 5000); // Check for inactivity every 5 seconds

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const events = ['click', 'keypress', 'scroll', 'mousemove'];

        const update = () => {
            updateExpiryTime();
        };

        events.forEach(event => window.addEventListener(event, update));

        return () => {
            events.forEach(event => window.removeEventListener(event, update));
        };
    }, []);

    return null;
};

export default InactivityLogoutTimer;
